import { render, staticRenderFns } from "./AttributesListTable.vue?vue&type=template&id=1ad778b4"
import script from "./AttributesListTable.vue?vue&type=script&lang=js"
export * from "./AttributesListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports